import type { JSX } from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import type { BlogPostDocument } from '@/types';

import { Blog } from '@/components';
import { createClient } from 'prismicio';

export type BlogPostProps = SliceComponentProps<Content.BlogPostsSlice>;

const BlogPosts = async ({ slice }: BlogPostProps): Promise<JSX.Element> => {
  let latestPosts: BlogPostDocument[] = [];

  if (slice.variation === 'latestPosts') {
    const prismicClient = createClient();

    const configLimit = slice?.primary?.limit || 8;
    const postBlogLimit = Math.min(configLimit, 25);

    const response = await prismicClient.getByType('blog_post', {
      pageSize: postBlogLimit,
      orderings: {
        field: 'my.blog_post.publish_date',
        direction: 'desc',
      },
    });

    latestPosts = response.results || [];
  }

  return <Blog latestPosts={latestPosts} slice={slice} />;
};

export default BlogPosts;
